import unlockImg from "./images/unlock-img.svg";
import gatacaLogoIcon from "./images/gatacaLogoIcon.svg";
import gatacaLogo from "./images/logoGataca.svg";
import gatacaLogoWhite from "./images/logoGataca-white.svg";
import appleBrandButtonIcon from "./images/appleBrandButton.svg";
import googleBrandButtonIcon from "./images/googleBrandButton.svg";
import scanButtonIcon from "./images/scanButtonIcon.svg";
import yellowWarning from "./images/gat-illustration-warning-yellow.svg";
import searchBar from "./images/search-bar.svg";
import notFoundPageBG from "./images/notFoundPage-bg.png";
import galaxyBlackHole from "./images/galaxyBlackHole.png";
import astronaut3D from "./images/astronaut_3D.png";
import startIcon from "./images/startIcon.svg";
import { LinkModel } from "../types/interfaces";
import { deleteSession } from "../store/session/sessionActions";

export const gaImages = {
  unlockImg: { src: unlockImg, alt: "unlock" },
  gatacaLogoIcon: { src: gatacaLogoIcon, alt: "Gataca Logo Icon" },
  gatacaLogo: { src: gatacaLogo, alt: "Gataca Logo" },
  gatacaLogoWhite: { src: gatacaLogoWhite, alt: "White Gataca Logo" },
  appleBrandButtonIcon: { src: appleBrandButtonIcon, alt: "App Store Logo" },
  googleBrandButtonIcon: {
    src: googleBrandButtonIcon,
    alt: "Play Store Logo",
  },
  scanButtonIcon: {
    src: scanButtonIcon,
    alt: "scan",
  },
  yellowWarning: {
    src: yellowWarning,
    alt: "warning",
  },
  searchBar: { src: searchBar, alt: "search" },
  notFoundPageBG: {
    src: notFoundPageBG,
    alt: "Not Found Page galaxy background",
  },
  galaxyBlackHole: {
    src: galaxyBlackHole,
    alt: "Galaxy black hole image",
  },
  astronaut3D: {
    src: astronaut3D,
    alt: "3D astronaut image",
  },
  startIcon: {
    src: startIcon,
    alt: "",
  },
};

export const marketAndroidLink =
  "https://play.google.com/store/apps/details?id=com.gataca.identity";

export const marketIosLink =
  "https://apps.apple.com/us/app/gataca/id1498607616";

export const gaColors = {
  neutral100: "#ffffff",
  neutral300: "#e4e4e4",
  neutral400: "#c6c6c8",
  neutral600: "#8c8c90",
  neutral700: "#707074",
  neutral1000: "#1E1E20",
  primaryColor: "#4745B7",
  alert300: "#DC3D43",
  success300: "#3D9A4E",
};

export const privacyPolicyGatacaUrl = "https://gataca.io/privacy-policy/";
export const cookiesPolicyGatacaUrl = "https://gataca.io/cookie-policy/";
export const legalNoticeGatacaUrl = "https://gataca.io/legal-notice/";
export const documentationGataca =
  "https://gataca.atlassian.net/wiki/spaces/DOCS/overview";
export const helpUrl = "https://gataca.io/company/contact/";

export const helpMenu: LinkModel[] = [
  {
    id: "support",
    route: "",
    label: "navigation.help.support",
    status: "active",
    outLink: helpUrl,
  },
  {
    id: "documentation",
    route: "",
    label: "navigation.help.documentation",
    status: "active",
    outLink: documentationGataca,
  },
];

export const profileMenuOptions: LinkModel[] = [
  {
    id: "logout",
    route: "",
    label: "navigation.logout",
    action: deleteSession,
  },
];

export enum TextAlignTypes {
  left = "left",
  center = "center",
  right = "right",
}

export enum CellContentTypes {
  text = "text",
  array = "array",
  name = "name",
  number = "number",
  date = "date",
  icon = "icon",
  checkbox = "checkbox",
  action = "action",
  detail = "detail",
  tag = "tag",
  modal = "modal",
}

export enum TooltipArrowPosition {
  right = "right",
  left = "left",
  center = "",
}

export enum TooltipPosition {
  right = "right",
  left = "left",
  bottom = "bottom",
  top = "",
}
